import { IModel, IPhotoModel, Model, PhotoModel } from ".";

export interface IVeterinarianSignatureModel extends IModel {
    veterinarianSinatureId: number
    veterinarianId: number
    photoId: number
    active: boolean
    signature: IPhotoModel
}

export class VeterinarianSignatureModel extends Model implements IVeterinarianSignatureModel {
    veterinarianSinatureId: number;
    veterinarianId: number;
    photoId: number;
    active: boolean;
    signature: IPhotoModel;

    constructor(params: IVeterinarianSignatureModel) {
        super(params);
        this.veterinarianSinatureId = params.veterinarianSinatureId;
        this.veterinarianId = params.veterinarianId;
        this.photoId = params.photoId;
        this.active = params.active;
        this.signature = params.signature && new PhotoModel(params.signature);
    }

}
